import { AdditionalColumnCellProps } from "PFApp/activities/manage_roles/parts/additional_column_cell/additional_column_cell.types";
import { Stack } from "PFComponents/containers";
import { useWatch } from "react-hook-form";

import css from "../cell.module.scss";

const ROLL_FORWARD_INFO_KEY = "rollforward_info";

export const RollForwardAdditionalColumnCell = ({
  column,
  rolesFormKey,
  renderCell,
  info
}: AdditionalColumnCellProps) => {
  const rollForwardPath = `${rolesFormKey}.${info.row.index}.original.${ROLL_FORWARD_INFO_KEY}`;
  const rollForwardInfo = useWatch({ name: rollForwardPath });
  const row = {
    original: {
      activity: {
        [ROLL_FORWARD_INFO_KEY]: rollForwardInfo
      }
    }
  };

  return <Stack className={css.cell}>{renderCell(column)({ ...info, row })}</Stack>;
};
